import React, { useState, useEffect } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { Modal, Box, IconButton } from "@mui/material";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { storeLoaction } from "../../redux/Slice/formSlice";

const containerStyle = {
  width: "100%",
  height: "calc(100% - 90px)",
};

const MapWithModal = ({
  placeholder,
  setLocation,
  location,
  error,
  helperText,
}) => {
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [mapVisible, setMapVisible] = useState(false);
  const [initialCenter, setInitialCenter] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [locationError, setLocationError] = useState(null);
  const dispatch = useDispatch();
  const apiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
  useEffect(() => {
    const fetchLocationCoordinates = async () => {
      try {
        if (location) {
          const results = await geocodeByAddress(location);
          const latLng = await getLatLng(results[0]);
          setInitialCenter(latLng);
          setSelectedPosition(latLng);
        } else if (navigator.geolocation && mapVisible) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const lat = position.coords.latitude;
              const lng = position.coords.longitude;
              setInitialCenter({ lat, lng });
              setSelectedPosition({ lat, lng });
              setLocationError(null);
            },
            (error) => {
              console.error("Geolocation error:", error);
              setLocationError(
                "Unable to fetch location. Please enable location services or enter an address manually."
              );
            }
          );
        } else {
          setLocationError("Geolocation is not supported by this browser.");
        }
      } catch (error) {
        console.error("Error fetching coordinates:", error);
        setLocationError("Error fetching location.");
      }
    };

    if (mapVisible) {
      fetchLocationCoordinates();
    }
  }, [mapVisible, location]);

  const handleSelect = async (value) => {
    try {
      const results = await geocodeByAddress(value);
      const latLng = await getLatLng(results[0]);
      setSelectedPosition(latLng);
      dispatch(storeLoaction(latLng));
      setLocation(value);
      setLocationError(null);
    } catch (error) {
      console.error("Error selecting location:", error);
    }
  };

  const handleMarkerDragEnd = async (event) => {
    const latLng = event.latLng;
    const lat = latLng.lat();
    const lng = latLng.lng();
    setSelectedPosition({ lat, lng });

    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
    try {
      const response = await fetch(geocodeUrl);
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        const newAddress = data.results[0].formatted_address;
        setLocation(newAddress);
        dispatch(storeLoaction({ lat, lng }));
      } else {
        console.error("No results found");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleModalOpen = () => {
    setMapVisible(true);
  };

  const handleModalClose = () => {
    setMapVisible(false);
  };

  return (
    <div>
      <div className="position-relative">
        <input
          placeholder={placeholder}
          className={`location-search-input w-100 ${error ? "error" : ""}`}
          onClick={handleModalOpen}
          value={location}
          onChange={(e) => setLocation(e.target.value)}
        />
        {helperText ? (
          <p className="location-err text-start">{helperText}</p>
        ) : null}
      </div>
      {/* Map Modal */}
      <Modal
        open={mapVisible}
        onClose={handleModalClose}
        disableEnforceFocus
        aria-labelledby="map-modal-title"
        aria-describedby="map-modal-description"
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: "650px",
            margin: "auto",
            padding: 2,
            backgroundColor: "background.paper",
            height: "90vh",
          }}
        >
          <IconButton
            onClick={handleModalClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 10,
              color: "text.primary",
            }}
          >
            <IoCloseCircleOutline size={28} />
          </IconButton>

          {/* Duplicate Location Input Field Inside Modal */}
          <div className="mb-2 mt-1 w-90">
            <PlacesAutocomplete
              value={location}
              onChange={setLocation}
              onSelect={(value) => {
                handleSelect(value);
                setSuggestions([]);
              }}
            >
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }) => (
                <div className="position-relative">
                  <input
                    {...getInputProps({
                      placeholder,
                      className: "location-search-input w-100",
                    })}
                  />
                  <div className="autocomplete-dropdown-container">
                    {loading && <div>Loading...</div>}
                    {suggestions.map((suggestion, index) => {
                      const style = suggestion.active
                        ? { backgroundColor: "#0000000a", cursor: "pointer" }
                        : { backgroundColor: "#ffffff", cursor: "pointer" };
                      return (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            className: "suggestion",
                            style,
                          })}
                          key={index}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>
          </div>

          {locationError && <p className="text-danger">{locationError}</p>}

          <GoogleMap
            mapContainerStyle={containerStyle}
            center={selectedPosition || initialCenter || { lat: 0, lng: 0 }}
            zoom={15}
          >
            <Marker
              position={selectedPosition || initialCenter || { lat: 0, lng: 0 }}
              draggable={true}
              onDragEnd={handleMarkerDragEnd}
            />
          </GoogleMap>
          <div className="text-center">

          <button onClick={handleModalClose} className="btn text-center  img-btn mt-2 primaryColor">Submit</button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default MapWithModal;
